import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-ring",
  "use": "spr-ring-usage",
  "viewBox": "0 0 22 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 25\" id=\"spr-ring\"><defs><path id=\"spr-ring_a\" d=\"M1047 1085h-22v-3.47l.69-.23c1.8-.59 2.29-2.53 2.88-5.67.52-2.81 1.12-6 3.8-7.55.33-.2.53-.56.53-.95a3.11 3.11 0 0 1 3.1-3.13c1.7 0 3.1 1.4 3.1 3.12 0 .4.2.76.54.96 2.67 1.55 3.27 4.74 3.8 7.55.58 3.14 1.07 5.08 2.87 5.67l.69.23zm-20-2h18v-.08c-2.46-1.22-3-4.11-3.53-6.92-.49-2.62-.95-5.1-2.83-6.19a3.1 3.1 0 0 1-1.54-2.69c0-.62-.5-1.12-1.1-1.12-.6 0-1.1.5-1.1 1.12a3.1 3.1 0 0 1-1.54 2.69c-1.88 1.1-2.34 3.57-2.83 6.19-.52 2.8-1.06 5.7-3.53 6.92zm9.03 6c-1 0-1.98-.56-2.56-1.46l-1-1.54h7.02l-.93 1.52a3.02 3.02 0 0 1-2.53 1.48z\" /></defs><use fill=\"#cd9932\" xlink:href=\"#spr-ring_a\" transform=\"translate(-1025 -1064)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/ring.svg
// module id = 281
// module chunks = 0